$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p === 'organizer_booking_area_table' && a === 'list') {
    let bookingAreaTableList = document.getElementById(
      'booking-area-table-list-sortable'
    );

    Sortable.create(bookingAreaTableList, {
      handle: '.booking-area-table-reorder',
      animation: 150,
      sort: true,
      delay: 0,
      touchStartThreshold: 0,
      disabled: false,
      draggable: '.booking-area-table',
      direction: 'horizontal',
      ghostClass: 'sortable-ghost',
      dataIdAttr: 'data-booking-area-table-id',
      removeCloneOnHide: true,
      store: {
        set: function (bookingAreaTableList) {
          let listOrder = bookingAreaTableList.toArray();
          ajaxListOrder(listOrder);
        },
      },
    });

    function ajaxListOrder(listOrder) {
      let bookingArea = $('body').attr('booking_area_id');

      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_booking_area_table/list_sort',
        data: {
          list_order: JSON.stringify(listOrder),
          booking_area_id: bookingArea,
        },
      })
        .done(function (data) {
          if (data === true) {
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
